import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=728ec523&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ec523",
  null
  
)

export default component.exports